import { render } from "./HeroiconsSolidLockOpen.vue?vue&type=template&id=1e428bee"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLockOpen.vue"]])

export default __exports__